export default __webpack_public_path__ + "static/orange_arrow_mobile-0724ee941a420d04fdbd7548ceab2d2c.svg";